import React, { Component } from "react";
import SlidingPanel from "react-sliding-side-panel";
import InfoCard from "./InfoCard";
import Table from "./Table";
import estados from "../../util/estados";
import Graficos from "./Graficos";
class SlidingPanelEmpreendimento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPaneOpen: props.isOpen,
            isPaneOpenLeft: false,
            panel_empreendimento_visible:
                this.props.panel_empreendimento_visible,
            estados: estados,
            cidades: [],
            ranges: [],
        };
    }

    componentDidMount() { }

    slidingPanel = () => {
        $("#card-results").toggleClass("collapsed");
        $("#btn-results").toggleClass("btn-results-off");
        $(".side-panel").toggleClass("side-panel-off");
        $(".sliding-panel-container").toggleClass("active");
        if ($("#results-icon").hasClass("fa-angle-double-left")) {
            $("#results-icon").removeClass("fa-angle-double-left");
            $("#results-icon").addClass("fa-angle-double-right");
        } else if ($("#results-icon").hasClass("fa-angle-double-right")) {
            $("#results-icon").removeClass("fa-angle-double-right");
            $("#results-icon").addClass("fa-angle-double-left");
        }
    }

    render = () => {
        let selectedAreas = this.props.overlays;
        return (
            <div
                className="col-md-4"
                style={{
                    backgroundColor: "#ffffff", overflow: "scroll", height: 0,
                }}
            >
                <div ref={(ref) => (this.el = ref)}>
                    <SlidingPanel
                        style={{ backgroundColor: "#ffffff" }}
                        className="some-custom-class"
                        panelContainerClassName="side-panel slider-align"
                        panelClassName=""
                        isOpen={this.props.state.isSlideOpen}
                        title="Informaçoes"
                        size={37}
                        noBackdrop={true}
                        type={"right"}
                    >
                        <>
                            <button id="btn-results" className="btn btn-sm background-brain" onClick={(e) => this.slidingPanel()} >
                                <i id="results-icon" className="fas fa-angle-double-right" aria-hidden="true" style={{ position: "relative", left: -5, }} ></i>
                            </button>

                            <div
                                id="card-results"
                                className="card card-results"
                                style={{ marginBottom: '10px' }}
                            >

                                <div className="card-header" style={{ zIndex: 2 }}>
                                    <h3 className="sliding-map-title letter-spacing-1" >
                                        Áreas selecionadas
                                    </h3>
                                </div>

                                <div
                                    className="card-body"
                                    style={{ paddingRight: 15, backgroundColor: "white", zIndex: 1, translate: "0px -25px" }}
                                >
                                    <div className="container" style={{ overflowX: "visible" }}>
                                        <div id="pdf">

                                            {this.props.loadingMetadata && (<>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        alignContent: "center",
                                                        height: "100%",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <img alt="carregando..." src="/img/loader.gif" />
                                                </div>
                                            </>)}

                                            {!this.props.loadingMetadata && (<>
                                                <div
                                                    className="container-fluid"
                                                    style={{ display: "flex", justifyContent: "space-between", alignContent: "center", alignItems: "center", }}
                                                ></div>
                                                {selectedAreas.map(
                                                    (selectedArea, index) => {
                                                        console.log("selectedArea", selectedArea);
                                                        return (
                                                            <div key={`selected-area-${index}`}>
                                                                {selectedArea.users?.length >
                                                                    0 && (
                                                                        <>
                                                                            <InfoCard
                                                                                selectedArea={selectedArea}
                                                                                color={selectedArea.color}
                                                                                type={selectedArea.type}
                                                                                getImageMapaUrl={this.props.getImageMapaUrl}
                                                                                mapScreenCaptureDataForPDF={this.props.state.mapScreenCaptureDataForPDF}
                                                                            />

                                                                            <Graficos
                                                                                selectedArea={selectedArea}
                                                                                color={selectedArea.color}
                                                                            />

                                                                            {/* <Table
                                                                                state={this.props.state}
                                                                                selectedArea={selectedArea}
                                                                                color={selectedArea.color}
                                                                                title={"Imóveis de interesse"}
                                                                            /> */}
                                                                        </>
                                                                    )}
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </>)}

                                        </div>
                                        <hr />
                                    </div>
                                </div>
                            </div>
                        </>
                    </SlidingPanel>
                </div>
            </div>
        );
    };
}

export default SlidingPanelEmpreendimento;
